(function(){
  if(window.__bsbInit)return;window.__bsbInit=1;
  document.documentElement.classList.add('bsb-js');
  function init(){
    document.querySelectorAll('[data-bsb-gallery]:not([data-bsb-ready])').forEach(function(g){
      g.setAttribute('data-bsb-ready','1');
      var btns=g.querySelectorAll('[data-bsb-thumb]'),slides=g.querySelectorAll('[data-bsb-slide]');
      btns.forEach(function(b,i){b.addEventListener('click',function(){
        btns.forEach(function(x){x.classList.remove('bsb-on')});b.classList.add('bsb-on');
        slides.forEach(function(s,k){s.hidden=(k!==i)});
      })});
    });
    document.querySelectorAll('[data-bsb-tabs]:not([data-bsb-ready])').forEach(function(root){
      root.setAttribute('data-bsb-ready','1');
      var tabs=[].slice.call(root.querySelectorAll('.bsb-tab')),pans=[].slice.call(root.querySelectorAll('.bsb-panel'));
      function pick(i,focus){
        tabs.forEach(function(t,k){var on=k===i;t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;
          if(pans[k]){pans[k].hidden=!on;pans[k].classList.toggle('bsb-on',on)}});
        if(focus)tabs[i].focus();
      }
      tabs.forEach(function(t,i){
        t.addEventListener('click',function(){pick(i)});
        t.addEventListener('keydown',function(e){
          if(e.key==='ArrowRight')pick((i+1)%tabs.length,1);
          if(e.key==='ArrowLeft')pick((i+tabs.length-1)%tabs.length,1);
        });
      });
    });
    document.querySelectorAll('[data-bsb-sticky]:not([data-bsb-ready])').forEach(function(bar){
      bar.setAttribute('data-bsb-ready','1');
      if(!('IntersectionObserver' in window))return;
      var ids=(bar.getAttribute('data-targets')||'').split(','),vis={};
      function upd(){var any=false;for(var k in vis){if(vis[k])any=true}bar.classList.toggle('bsb-show',!any)}
      ids.forEach(function(id){
        var el=document.getElementById(id.trim());if(!el)return;vis[id]=false;
        new IntersectionObserver(function(e){vis[id]=e[0].isIntersecting;upd()}).observe(el);
      });
      upd();
    });
    var rvSel='.bsb-scard,.bsb-use-card,.bsb-callout,.bsb-stat,.bsb-ing,.bsb-sgrid li,.bsb-review,.bsb-tw,.bsb-offer,.bsb-split>*,.bsb-faq details,.bsb-tlx,.bsb-box';
    var els=[].slice.call(document.querySelectorAll(rvSel)).filter(function(e){return !e.hasAttribute('data-bsb-rv')&&!e.closest('.bsb-hero')});
    els.forEach(function(e,i){e.setAttribute('data-bsb-rv','1');e.classList.add('bsb-rv');
      var sibs=e.parentElement?[].slice.call(e.parentElement.children).indexOf(e):0;e.style.setProperty('--d',((sibs%4)*80)+'ms')});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('bsb-in');io.unobserve(x.target)}})},{threshold:0,rootMargin:'0px 0px -4% 0px'});
      els.forEach(function(e){io.observe(e)});
    }else{els.forEach(function(e){e.classList.add('bsb-in')})}
    setTimeout(function(){els.forEach(function(e){var r=e.getBoundingClientRect();if(r.top<window.innerHeight*1.2)e.classList.add('bsb-in')})},1800);
    window.addEventListener('load',function(){setTimeout(function(){els.forEach(function(e){if(!e.classList.contains('bsb-in')&&e.getBoundingClientRect().bottom>document.documentElement.scrollHeight-40)e.classList.add('bsb-in')})},600)});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
